<template>
  <div class="container">
    <div class="app-container">
      <div class="selectors-container">
        <SizeSelector @size-changed="onSizeChange" />
        <IndexSelector @index-changed="onIndexChange" />
      </div>

      <div class="button-container">
        <button @click="$emit('load-puzzle')" class="load-button">Cargar Puzzle</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SizeSelector from '../SizeSelector/SizeSelector.vue'
import IndexSelector from '../IndexSelector/IndexSelector.vue'

interface Emits {
  (e: 'size-changed', size: number): void
  (e: 'index-changed', index: number): void
  (e: 'load-puzzle'): void
}

const emit = defineEmits<Emits>()

const onSizeChange = (size: number): void => {
  emit('size-changed', size)
}

const onIndexChange = (index: number): void => {
  emit('index-changed', index)
}
</script>

<style scoped>
.container {
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.app-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.selectors-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 10px;
}

.button-container {
  margin-top: 5px;
}

.load-button {
  background-color: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.load-button:hover {
  background-color: #2980b9;
}

@media (max-width: 1200px) {
  .container {
    position: static !important;
    margin: 10px auto;
    width: 95%;
  }

  .selectors-container {
    flex-direction: row;
    align-items: stretch;
  }

  .app-container {
    flex-direction: row;
    gap: 10px;
  }
}
</style>
